var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-surface-secondary w-100" }, [
    _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
      _c("div", { staticClass: "container-fluid py-4" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
              _c("div", [
                _c("button", {
                  staticClass: "btn-close text-xs",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vr opacity-20 my-1" }),
              _vm._v(" "),
              _c("h1", { staticClass: "h4 ls-tight" }, [
                _vm._v("Editar Prealerta"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto" }, [
            _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-success px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.UPDATE()
                    },
                  },
                },
                [
                  _vm.count == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Guardar")]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid vstack gap-5" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Tracking")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group input-group-sm" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control form-control-sm",
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.data.tracking },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Valor")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.value,
                        expression: "data.value",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.value ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.value },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "value", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.errors.value, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Descripción"),
                ]),
                _vm._v(" "),
                _c("v-combobox", {
                  staticClass: "form-control form-control-sm textarea",
                  class: _vm.errors.description ? "is-invalid" : "",
                  attrs: {
                    chips: "",
                    "hide-details": "",
                    multiple: "",
                    clearable: "",
                    delimiters: [","],
                    "search-input": _vm.search_description,
                  },
                  on: {
                    "update:searchInput": function ($event) {
                      _vm.search_description = $event
                    },
                    "update:search-input": [
                      function ($event) {
                        _vm.search_description = $event
                      },
                      _vm.MEOW_INPUT,
                    ],
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        var item = ref.item
                        var select = ref.select
                        var selected = ref.selected
                        return [
                          _c(
                            "v-chip",
                            _vm._b(
                              {
                                attrs: {
                                  small: "",
                                  close: "",
                                  "input-value": selected,
                                },
                                on: {
                                  "click:close": function ($event) {
                                    return _vm.REMOVE(item)
                                  },
                                },
                              },
                              "v-chip",
                              attrs,
                              false
                            ),
                            [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v(_vm._s(item)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.data.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "description", $$v)
                    },
                    expression: "data.description",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.description, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Subir Archivo"),
                  ]),
                  _vm._v(" "),
                  _c("v-file-input", {
                    staticClass:
                      "form-control form-control-sm cursor-pointer p-0",
                    class: _vm.errors.files ? "is-invalid border-danger" : "",
                    attrs: {
                      "hide-details": "",
                      "truncate-length": "50",
                      multiple: "",
                      accept: "application/pdf, image/*",
                      placeholder:
                        "Debe adjuntar la factura del producto y copia de su documento de identificación",
                    },
                    on: { change: _vm.UPLOAD_FILES },
                    model: {
                      value: _vm.fileInput,
                      callback: function ($$v) {
                        _vm.fileInput = $$v
                      },
                      expression: "fileInput",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.files, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.data.files, function (item, index) {
                return _c("div", { key: index, staticClass: "mb-1" }, [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "a",
                      {
                        staticClass: "card-body text-decoration-none",
                        attrs: {
                          href: "" + item.path,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between",
                          },
                          [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c(
                                "small",
                                { staticClass: "mb-1 text-decoration-none" },
                                [_c("b", [_vm._v(_vm._s(item.name))])]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted d-flex" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass: "mr-3",
                                    staticStyle: { "font-size": "10px" },
                                  },
                                  [
                                    _vm._v(
                                      "size: " +
                                        _vm._s(_vm._f("SIZE")(item.size))
                                    ),
                                  ]
                                ),
                                _c(
                                  "small",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "type: " +
                                        _vm._s(item.name.split(".").pop())
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-dark font-weight-bold text-decoration-none",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.REMOVE_FILE(item.id, index)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fa-solid fa-close" })]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }),
          _vm._v(" "),
          _vm._m(2),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _vm._v(
          "\n                                    #\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    $\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 d-flex" }, [
      _c(
        "small",
        {
          staticClass: "text-muted text-justify",
          staticStyle: { "font-size": "10px" },
        },
        [
          _vm._v(
            "* El trámite tiene un costo de 20 Dólares Americanos (20.00 USD). "
          ),
          _c("br"),
          _vm._v("Se puede realizar máximo una vez cada 6 meses."),
          _c("br"),
          _vm._v(
            " Debe adjuntar la factura del producto y copia de su documento de identificación."
          ),
          _c("br"),
          _vm._v(
            " De no cumplir con los requisitos el trámite será rechazado."
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }